import { render } from "./1.vue?vue&type=template&id=764b98fd&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"

import "./1.vue?vue&type=style&index=0&id=764b98fd&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764b98fd"]])

export default __exports__